import React from 'react';
import AnswersView from 'shared/decision/AnswersView';

/**
 * What a decide step chose and why: the route, the answer behind it per
 * question, and every answer's probabilities. `verb` is "Took" for a run,
 * "Would take" for a test.
 */
export default function DecideResult({ questions, route, because, answers, verb = 'Took' }) {
  return (
    <div className="space-y-2" data-testid="decide-result">
      <p className="text-[12px] text-[color:var(--text-muted)]">
        {verb}{' '}
        <span className="font-medium text-[color:var(--text-primary)]">{route || 'no route'}</span>
      </p>
      {Array.isArray(because) && because.length ? (
        <ul className="space-y-0.5 text-[12px] text-[color:var(--text-secondary)]">
          {because.map((b) => <li key={b} className="font-mono">{b}</li>)}
        </ul>
      ) : null}
      {answers ? <AnswersView questions={questions || {}} answers={answers} /> : null}
    </div>
  );
}
